﻿function TicketInsurance() {


    function initEnableTicketInsurance() {       

        var $ticketInsuranceArea = $("#ticket-insurance-area")

        if ($ticketInsuranceArea.hasClass("enable-ticket-insurance")) {
            initPersistentCheckboxes();
        }
        else {
            $ticketInsuranceArea.hide();
            localStorage.removeItem('ticketInsuranceCheckboxValues');

        }


    }

    function initPersistentCheckboxes() {

        var $ticketInsuranceContinueForm = $("#ticket-insurance-continue-form");
        var checkboxValues = JSON.parse(localStorage.getItem('ticketInsuranceCheckboxValues')) || {};
        var $checkboxes = $("#ticket-insurance-checkbox-container :checkbox");
        var $klarnaCheckoutField = $("#klarna-checkout-field");
        var $ticketInsuranceContinueButtonField = $("#ticket-insurance-continue-button-field");
        var $ticketInsuranceContinueButton = $("#ticket-insurance-continue-button");
        var $ticketInsuranceAreaDetails = $("#ticket-insurance-area-details");
        var $checkboxYes = $("#ticket-insurance-checkbox-yes");

        if ($ticketInsuranceContinueButtonField.hasClass("enable-ticket-insurance-continue-button") && $ticketInsuranceContinueButtonField.hasClass("ticket-insurance-continue-button-is-required")) {
            $ticketInsuranceContinueButtonField.show();
            $klarnaCheckoutField.hide();
        }
        else {
            $ticketInsuranceContinueButtonField.hide();
            $klarnaCheckoutField.show();
        }

        if ($ticketInsuranceContinueButtonField.hasClass("ticket-insurance-continue-button-is-required"))
        {
            $ticketInsuranceContinueButton.on("click", function () {
                var checkboxValues = JSON.parse(localStorage.getItem('ticketInsuranceCheckboxValues')) || {};
                var hasValue = false;
                $.each(checkboxValues, function (key, value) {
                    if (value == true) {
                        hasValue = true;
                    }
                });
                if (hasValue == true) {
                    $ticketInsuranceContinueForm.submit();
                }
                else {
                    $ticketInsuranceAreaDetails.addClass("border border-danger");
                }
            });
        }


        $checkboxes.on("change", function () {
            $checkboxes.each(function () {
                checkboxValues[this.id] = this.checked;
            });

            localStorage.setItem("ticketInsuranceCheckboxValues", JSON.stringify(checkboxValues));
        });

        // On page load
        $.each(checkboxValues, function (key, value) {
            $("#" + key).prop('checked', value);
        });

        if ($ticketInsuranceContinueButtonField.hasClass("ticket-insurance-continue-button-is-not-required")) {

            $checkboxYes.on("change", function () {
                $ticketInsuranceContinueForm.submit();
            });
        }

        
    }


    this.initPersistentCheckboxes = initPersistentCheckboxes;
    this.initEnableTicketInsurance = initEnableTicketInsurance;
    return this;
};

export default TicketInsurance;